export type PageSessionType = 'clinical' | 'general';

export type RouteHandle = {
  sessionType?: PageSessionType;
};

export function getSessionTypeFromPathname(pathname: string): PageSessionType {
  if (pathname.startsWith('/dashboard/clinical')) return 'clinical';
  if (/^\/transaction\/[^/]+/.test(pathname)) return 'clinical';
  return 'general';
}

export function isClinicalDestination(destination: string): boolean {
  const path = destination.split('?')[0];
  return getSessionTypeFromPathname(path) === 'clinical';
}

export function isClinicalSession(sessionType: PageSessionType): boolean {
  return sessionType === 'clinical';
}
